import { render, staticRenderFns } from "./barchart_component.vue?vue&type=template&id=6d3af298"
import script from "./barchart_component.vue?vue&type=script&lang=js"
export * from "./barchart_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports